import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../PrivateRoute';

import { List } from './List';


function Reports({ match }) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={List} />
        </Switch>
    );
}

export { Reports };